import PropTypes from "prop-types";
import { Avatar } from "@components";
import { Image } from "@chakra-ui/react";
import pointsIcon from "@assets/svg/icon-points.svg";
import coinsIcon from "@assets/svg/icon-coin.svg";

const NotificationImage = ({ type, meta }) => {
  let data;

  switch (type) {
    case "participant":
    case "message": {
      const { avatar, color } = meta || {};
      data = {
        avatar,
        color,
      };
      break;
    }
    case "points":
      data = pointsIcon;
      break;
    case "coins":
      data = coinsIcon;
      break;

    default:
      break;
  }

  return type === "participant" || type === "message" ? (
    <Avatar size="xs" showBorder={true} {...data} />
  ) : (
    <Image src={data} />
  );
};

NotificationImage.propTypes = {
  type: PropTypes.string,
};

export default NotificationImage;
